/**
 * Rastreamento
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {RastreamentoCollection} from '@/model/collection/RastreamentoCollection'

/* TODO: review generated class */
export class Rastreamento extends Resource {
  idRastreamentoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  placa: string | null = null
  codigoViagem: string | null = null
  latitude: number | null = null
  longitude: number | null = null
  dataUltimaPosicao: string | null = null

  endereco: string | null = null
  numeroParadas: string | null = null
  codigoRastreioVeiculo: string | null = null

  get $id() {
    return this.idRastreamentoPk
  }
  set $id(val) {
    this.idRastreamentoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of Rastreamento
   */
  async getRastreamento(id: number) {
    return await Request.get(`/admin/rastreamento/${id}`)
      .name('getRastreamento')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of Rastreamento
   */
  static async listRastreamento(params: any) {
    return await Request.get(`/admin/rastreamento`, {params})
      .name('listRastreamento')
      .as(RastreamentoCollection)
      .getData()
  }

  /**
   * Persists a new instance of Rastreamento. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistRastreamento() {
    return await Request.post(`/admin/rastreamento`, this)
      .name('persistRastreamento')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Rastreamento to use it in a CSV file
   */
  static async listCsvRastreamento(params: any) {
    return await Request.get(`/admin/rastreamento/csv`, {params})
      .name('listCsvRastreamento')
      .as(RastreamentoCollection)
      .getData()
  }
}
